<ng-container *ngIf="!!params">
    <tt-divider ttRememberId="docpacktypechapters_dividers">
        <tt-divider-columns>
            <tt-divider-pane ttSize="60">
                <tt-grid *ngIf="!!grid" class="col-xs-12 sp-0 flex-1" [(ttOptions)]="grid" (ttOnRowSelected)="onRowSelected($event)"></tt-grid>
            </tt-divider-pane>
            <tt-divider-pane ttSize="40">
                <tt-doc-pack-type-chapter
                    *ngIf="!!selectedDocPackTypeChapter"
                    [params]="{ docpacktype_keyno: params.docpacktype_keyno, docpacktypechapter_keyno: selectedDocPackTypeChapter }"
                    (submit)="onChapterSubmit($event)"
                ></tt-doc-pack-type-chapter>
            </tt-divider-pane>
        </tt-divider-columns>
    </tt-divider>
</ng-container>
